export var ModalType;
(function(ModalType) {
    ModalType["STATUS_UPDATE"] = "STATUS_UPDATE";
    ModalType["JOURNAL"] = "JOURNAL";
    ModalType["LITERATURE"] = "LITERATURE";
    ModalType["COMMISSION"] = "COMMISSION";
    ModalType["CONFIRMATION"] = "CONFIRMATION";
    ModalType["GLOBAL_CONFIRMATION"] = "GLOBAL_CONFIRMATION";
    ModalType["GLOBAL_CONFIRMATION_FOR_MM"] = "GLOBAL_CONFIRMATION_FOR_MM";
    ModalType["POLL_EDIT"] = "POLL_EDIT";
    ModalType["GIVE_BADGE"] = "GIVE_BADGE";
    ModalType["GIVE_POINTS"] = "GIVE_POINTS";
    ModalType["GIVE_POINTS_SUCCESS"] = "GIVE_POINTS_SUCCESS";
    ModalType["GIVE_ITEM_FAILURE"] = "GIVE_ITEM_FAILURE";
    ModalType["COMMENT_THREAD"] = "COMMENT_THREAD";
    ModalType["VERIFICATION"] = "VERIFICATION";
    ModalType["VERIFICATION_SUCCESSFUL"] = "VERIFICATION_SUCCESSFUL";
    ModalType["DEVIATION_BACKGROUND_PICKER"] = "DEVIATION_BACKGROUND_PICKER";
    ModalType["USER_BLOCK"] = "USER_BLOCK";
    ModalType["REPORT_DEVIATION_MODAL"] = "REPORT_DEVIATION_MODAL";
    ModalType["MOBILE_DEVIATION_SHARE"] = "MOBILE_DEVIATION_SHARE";
    ModalType["DEVIATION_GROUP_LIST"] = "DEVIATION_GROUP_LIST";
    ModalType["MOBILE_DEVIATION_PCP"] = "MOBILE_DEVIATION_PCP";
    ModalType["USER_SYMBOLS_LEGEND"] = "USER_SYMBOLS_LEGEND";
    ModalType["MOBILE_CHAT_LIST"] = "MOBILE_CHAT_LIST";
    ModalType["MOBILE_CHAT_WINDOW"] = "MOBILE_CHAT_WINDOW";
    ModalType["MOBILE_CHAT_WINDOW_NEW"] = "MOBILE_CHAT_WINDOW_NEW";
    ModalType["COOKIE_SETTINGS"] = "COOKIE_SETTINGS";
    ModalType["AWARD_BADGE"] = "AWARD_BADGE";
    ModalType["RECEIVED_AWARDS"] = "RECEIVED_AWARDS";
    ModalType["TIER_EDIT"] = "TIER_EDIT";
    ModalType["TIER_UNSUBSCRIBE"] = "TIER_UNSUBSCRIBE";
    ModalType["TIER_UNSUBSCRIBE_BY_USERNAME"] = "TIER_UNSUBSCRIBE_BY_USERNAME";
    ModalType["TIER_CHANGE"] = "TIER_CHANGE";
    ModalType["MOBILE_SHARE"] = "MOBILE_SHARE";
    ModalType["GROUP_CLOSED_WATCH"] = "GROUP_CLOSED_WATCH";
    ModalType["GROUP_JOIN_PENDING"] = "GROUP_JOIN_PENDING";
    ModalType["FAVOURITED_BY"] = "FAVOURITED_BY";
    ModalType["DEVIANTS_LIST"] = "DEVIANTS_LIST";
    ModalType["COLLECTION_POPOVER"] = "COLLECTION_POPOVER";
    ModalType["DAS_MODAL"] = "DAS_MODAL";
    ModalType["LOADING_SCREEN"] = "LOADING_SCREEN";
    ModalType["CREATE_PREMIUM_FOLDER"] = "CREATE_PREMIUM_FOLDER";
    ModalType["DEALER"] = "DEALER";
    ModalType["DEVIATION_SUBMIT"] = "DEVIATION_SUBMIT";
    ModalType["DISCORD_CONNECT_SUCCESS"] = "DISCORD_CONNECT_SUCCESS";
    ModalType["DISCORD_DISCONNECT"] = "DISCORD_DISCONNECT";
    ModalType["NFT_LINK"] = "NFT_LINK";
    ModalType["BADGE_INFO"] = "BADGE_INFO";
    ModalType["WEB3_WALLET"] = "WEB3_WALLET";
})(ModalType || (ModalType = {}));
